import { createSelector } from '@reduxjs/toolkit';

const baseSelector = (state) => state.capstoneSubmission;

export const currentPageSelector = createSelector(
  (state) => baseSelector(state).currentPage,
  (currentPage) => currentPage
);

export const resolveSubmissionModalStateSelector = createSelector(
  (state) => baseSelector(state).resolveSubmissionModalState,
  (resolveSubmissionModalState) => resolveSubmissionModalState
);

export const selectedSubmissionSelector = createSelector(
  (state) => baseSelector(state).selectedSubmission,
  (selectedSubmission) => selectedSubmission
);

export const learnerEmailSelector = createSelector(
  (state) => baseSelector(state).learnerEmail,
  (learnerEmail) => learnerEmail
);
